import { type CreateOpportunityPayload, type Customer } from "@repo/api";
import isEmpty from "lodash/isEmpty";

import { type NewProjectState } from "./NewProjectReducer";

const getCustomerInfo = (theCustomer: Customer) => ({
  firstName: theCustomer.firstName,
  lastName: theCustomer.lastName,
  email: theCustomer.email,
  phone: theCustomer.phoneNumber,
  partyId: theCustomer.partyId,
  customerType: theCustomer.customerType,
  familyCardNumber: theCustomer.familyNumber || "",
  bcmId: theCustomer.bcmId,
  organizationName: theCustomer.organizationName,
  customerAccountState: theCustomer.customerAccountState,
});

const getCustomerLocale = (
  state: NewProjectState,
  locale: string,
  language: string
) => {
  const countryCode =
    state.customerInfo?.country ?? state.customerInfo?.countryCode ?? locale;
  const languageCode = state.customerInfo?.language?.includes("_") // customer.language can be pt_PT
    ? state.customerInfo.language.slice(0, 2)
    : (state.customerInfo?.languageCode ?? language);

  return (
    state.customerInfo?.customerLocale ??
    `${languageCode.toLowerCase()}-${countryCode.toUpperCase()}`
  );
};

export const getProjectPayload = (
  state: NewProjectState,
  locale: string,
  language: string
): CreateOpportunityPayload => {
  const cmpCode =
    state.associatedTask?.cmpCode ??
    window.salja?.coworkerprofile?.data?.store?.No;
  const cmpName =
    state.associatedTask?.cmpName ??
    window.salja?.coworkerprofile?.data?.store?.Name;

  const customerConsents = isEmpty(state.manualConsents)
    ? state.customerConsents
    : state.manualConsents;

  return {
    opportunityInfo: {
      title: state.opportunityInfo.title,
      sourceSystem: state.profile?.department || undefined,
      source: "SLA",
      createdBy: state.profile?.mail || undefined,
      customerLocale: getCustomerLocale(state, locale, language),
      assignedTo: state.assignedCoworker?.emailId || undefined,
      assignedTeam: state.assignedTeam?.toString() || undefined,
      businessUnit: {
        buCode: cmpCode,
        buType: "STO",
        buName: cmpName,
      },

      CustomerInterestIndex: "Medium",
      CustomerReadiness: "Exploring",
      hfb: state.opportunityInfo.hfb,
      customerMeetingPointBuCode: cmpCode,
    },

    customerInfo: {
      ...getCustomerInfo(state.customerInfo!),
      preferredContactType: state.contactMethod ?? "EMAIL",
      customerConsents,
    },
    confirmationMessage: state.sendConfirmation
      ? {
          type: state.contactMethod,
          contact:
            state.contactMethod === "EMAIL"
              ? state.customerInfo?.email
              : state.customerInfo?.phoneNumber,
        }
      : undefined,
    retailUnit: window.salja?.coworkerprofile?.data?.store?.No,
    dropInAppointmentId: state.associatedDropInAppointment?.id,
  };
};
